import { MENTION_TOKEN_WITH_ID_PATTERN } from '@/helpers/assignPersonMention';

import { type MessageWithTextContent, type TaggedUser } from './types';

/**
 * Resolves @-mention DSL tokens ({{@personId}}) to readable names (@Name).
 * Falls back to @{Unknown} if the user is not found in taggedUsers.
 */
function resolveMentions(text: string, taggedUsers: TaggedUser[] = []): string {
  return text.replace(MENTION_TOKEN_WITH_ID_PATTERN, (match, personId: string) => {
    const user = taggedUsers.find((taggedUser) => taggedUser.id === personId);
    if (user?.name) {
      return `@${user.name}`;
    }
    return '@{Unknown}';
  });
}

/**
 * Extracts plain text content from a message, stripping HTML if needed.
 * Resolves @-mention DSL tokens to readable names.
 * Returns an empty string if no text content is available.
 */
export function getMessageTextContent(message: MessageWithTextContent): string {
  let text = '';

  if (message.text) {
    text = message.text;
  } else if (message.richText?.html && typeof document !== 'undefined') {
    const tempElement = document.createElement('div');
    tempElement.innerHTML = message.richText.html;
    text = tempElement.textContent || tempElement.innerText || '';
  }

  if (!text) {
    return '';
  }

  return resolveMentions(text, message.taggedUsers);
}
